import { Dispatch } from 'react';
import api from 'src/api/api';
import { HEADERS } from 'src/constants/headers';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { GET_STORE_GROUPS } from '../constants/actions';
import { TStoreGroupActionTypes, TStoreGroupPagination } from '../types';

/**
 * Will return store groups with pagination and search
 *
 * @param {Dispatch<TStoreGroupActionTypes>} dispatch
 * @param {TStoreGroupPagination} pagination
 * @param {string} query
 * @param {string} typeQuery
 */
export const getStoreGroups = async (
    dispatch: Dispatch<TStoreGroupActionTypes>,
    pagination: TStoreGroupPagination,
    query?: string
) => {
    dispatch({ type: SET_LOADING });
    try {
        let res;
        const searchText = query || '';

        if (pagination) {
            res = await api.post(
                '/store-groups/search',
                {
                    page: pagination.page,
                    limit: pagination.limit,
                    name: searchText,
                    description: '',
                },
                HEADERS()
            );
        }

        dispatch({
            type: GET_STORE_GROUPS,
            payload: res.data.results,
            count: res.data.pagination?.total,
        });
    } catch (error) {
        dispatch(handleError(error, null));
    }
};
